export default {
    fund: [{
            "title": "基金年度报告的信息披露应包括（　　）。",
            "questions": "I. 经审计的基金财务会计报告<br>II. 基金托管报告<br>III. 基金管理人报告<br>IV. 更新的基金合同",
            "question": "A. I、III、IV\nB. I、II、III、IV\nC. I、II、III\nD. II、III、IV",
            "answer": "B",
            "explain": "本题考查基金年度报告的内容。基金年度报告的主要内容：（1）正文与摘要的披露；（2）基金财务会计报告；（3）基金投资组合报告；（4）基金合同约定的其他信息。"
        },
        {
            "title": "关于基金产品的风险评价，以下表述正确的是（　　）。",
            "question": "A. 基金销售机构不能对基金产品进行风险评价\nB. 由基金评级与评价机构提供基金产品风险评价服务的，基金销售机构应当要求服务方提供基金产品风险评价方法及说明\nC. 根据中国证券投资基金业协会发布的《基金募集机构投资者适当性管理实施指引(试行)》，基金产品的风险等级至少分为四个\nD. 基金产品风险评价结果不能作为销售机构向基金投资人推介基金产品的重要依据",
            "answer": "B",
            "explain": "本题考查基金产品的风险评价。A选项表述错误，对基金产品的风险评价，可以由基金销售机构的特定部门完成，也可以由第三方的基金评级与评价机构提供。B选项表述正确，由基金评级与评价机构提供基金产品风险评价服务的，基金销售机构应当要求服务方提供基金产品风险评价方法及说明。C选项表述错误，基金产品风险评价以基金产品的风险等级来具体反映，其产品至少分五个等级:R1、R2、R3、R4和R5(而不是四个等级)。D选项表述错误，基金产品风险评价结果应当作为销售机构向基金投资人推介基金产品的重要依据。"
        },
        {
            "title": "关于契约型基金，以下说法正确的是（　　）。",
            "question": "A. 基金份额持有人按所持有股份承担有限责任，分享投资收益\nB. 契约型基金设有董事会\nC. 基金投资者根据持有的基金份额比例享有基金投资收益，承担相应投资亏损",
            "answer": "D",
            "explain": "本题考查契约型基金。A选项说法错误，公司型基金的持有人按所持有股份承担有限责任，分享投资收益。B选项说法错误，公司型基金公司设有董事会，代表投资者的利益行使职权。C选项说法错误，公司型基金的投资者是基金公司的股东，享有股东权，按所持有的股份承担有限责任。D选项说法正确，契约型基金的投资者根据持有的基金份额比例享有基金投资收益，承担相应投资亏损。"
        },
        {
            "title": "关于基金客户档案的管理与保密，以下表述错误的是（　　）。",
            "question": "A. 需要建立严格的基金份额持有人信息管理制度和保密制度\nB. 信息技术负责人和信息安全负责人可以由同一人担任，对重要业务环节实行双人双岗\nC. 系统运行数据中，涉及基金投资人信息和交易记录的备份应在不可修改的介质上保存\nD. 数据应逐日备份并异地妥善存放",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于职业道德和法律的区别，以下说法错误的是（　　）。",
            "question": "A. 法律由国家强制力保证实施，职业道德则没有\nB. 法律由假定、处理和制裁构成，而职业道德没有明确的制裁措施或行为后果\nC. 法律调整外在行为和结果，职业道德不仅要调整外在行为和结果，还要调整人们内在的精神世界和心理动机\nD. 职业道德以价值判断为标准而法律不限于价值判断或不直接反映价值判断",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "A基金管理公司与B投资顾问签订的《投资顾问服务协议》约定，A旗下部分产品由B直接下单交易，事先不通过A的风控系统，A对上述产品应承担的责任一并转移给B承担。关于上述情况，以下说法错误的包括（　　）。",
            "questions": "I. A没有谨慎勤勉地履行管理人职责<br>II. A没有独立自主地进行投资决策<br>III. A依法应当承担的责任因委托B投资顾问而免除",
            "question": "A. II、IV\nB. III、IV\nC. I、III\nD. I、II",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于基金认购的概念，以下表达正确的是（　　）。",
            "question": "A. 投资者在募集期内购买某只基金份额的行为\nB. 投资者首次购买某只基金份额的行为\nC. 投资者通过基金直销渠道认购某只基金份额的行为\nD. 投资者在开放期内购买某只基金份额的行为",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "通常在开放式基金申购赎回中，可以不采用未知价交易原则的基金品种为（　　）。",
            "question": "A. 股票型基金\nB. 货币市场基金\nC. 债券型基金\nD. 混合型基金",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "基金托管人应对基金管理人编制的（　　）等公开披露的相关基金信息进行复核、审查，并向基金管理人出具书面文件或者盖章确认。",
            "questions": "I. 基金资产及份额净值<br>II. 申购赎回价格<br>III. 基金定期报告<br>IV. 定期更新的招募说明书",
            "question": "A. I、II、III、IV\nB. I、II\nC. I、II、III\nD. III、IV",
            "answer": "A",
            "explain": ""
        }, {
            "title": "下列属于基金公司合规管理部门基本职责的是（　　）。",
            "question": "A. II、IV\nB. I、II、III、IV\nC. I、II\nD. III",
            "questions": "I. 草拟公司风险管理战略，制定并执行风险为本的合规管理计划<br>II. 独立梳理和修订各业务条线的各项政策、程序和操作指南，确保各项政策、程序和操作指南符合法律、规则和准则的要求<br>III. 收集、筛选可能预示潜在合规问题的数据，如消费者投诉的增长数、异常交易等<br>IV. 定期或者不定期向全体董事报送工作报告",
            "answer": "D",
            "explain": "本题考查合规管理机构设置及其责任。"
        },
        {
            "title": "关于专业投资者和普通投资者，以下描述正确的是（　　）。",
            "question": "A. 专业投资者是大的机构，在基金经营机构享有不同于普通投资者的优先服务\nB. 相对于普通投资者，专业投资者的风险识别能力更弱\nC. 专业投资者是单个行业具有较强投资能力的投资者，普通投资者是在多个行业都有较强能力的投资者\nD. 专业投资者与基金经营机构发生纠纷，适用谁主张谁举证原则，普通投资者与基金经营结构发生纠纷，适用举证责任倒置原则，基金经营机构应提供相关资料，证明其已向普通投资者履行相应义务",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "根据私募基金合格投资者的相关阐述，以下属于禁止行为的是（　　）。",
            "question": "A. I、II、III\nB. I、III\nC. II、III\nD. I、II",
            "questions": "I. 向非合格投资者销售私募基金<br>II. 在确认投资者实质不符合合格投资者标准的情况下，仍予以销售确认<br>III. 通过拆分转让私募基金份额，间接突破合格投资者标准",
            "answer": "A",
            "explain": "本题考查基金销售的禁止行为。私募基金应当向合格投资者募集，禁止以下行为："
        },
        {
            "title": "规章、制度、纪律等属于行为规范的范畴，下列有关说法错误的是（　　）。",
            "question": "A. 是介于法律和道德之间的一种特殊的规范\nB. 其约束力与法律一样，具有普遍强制性\nC. 通常由特定组织制定，不太强调价值判断，具有突破性的技术\nD. 具有强于道德而弱于法律的约束力，具有一定的强制性",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "私募基金可以通过以下哪种方式进行宣传（　　）。",
            "question": "A. 海报、户外广告\nB. 公共门户网站、链接广告和博客\nC. 公开出版资料\nD. 对特定客户推送产品说明",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "巨额赎回的确认标准为：单个开放日基金净赎回申请超过基金总份额的（　　）。",
            "question": "A. 5%\nB. 15%\nC. 10%\nD. 20%",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "根据《证券投资基金法》的规定，关于基金托管人的职责，以下表述错误的是（　　）。",
            "question": "A. 安全保管基金财产\nB. 保存基金托管业务活动的记录、账册、报表和其他相关材料\nC. 编制基金财务会计报告\nD. 按照规定开设基金财产的资金账户和证券账户",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "某公募基金管理公司对外大力宣传公司新推出的一款基金产品，以下做法正确的是（　　）。",
            "question": "A. 相关推介材料登载其他基金的过往业绩并标明数据的出处\nB. 以报刊方式发布基金宣传广告，并在5个工作日内向中国证券投资基金业协会进行宣传资料的备案\nC. 由分管投资研究的高管，对于宣传资料进行检查力并出具合规意见书\nD. 引用基金评价机构的评价结果并列明，基金评价机构的名称，省略评价日期",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于QDII基金的认购，以下表述错误的是（　　）。",
            "questions": "I. QDII基金份额面值都为1元<br>II. QDII计价货币只能是人民币<br>III. QDII基金管理人应具备经营外汇业务的资格<br>IV. QDII基金管理人应具备合格境内机构投资者的资格",
            "question": "A. I、III\nB. II、III\nC. I、II\nD. I、IV",
            "answer": "C",
            "explain": ""
        }, {
            "title": "基金管理人可以从开放式基金财产中计提一定比例的（　　），用于基金的持续销售和给基金份额持有人提供服务。",
            "question": "A. 赎回费\nB. 认购费\nC. 申购费\nD. 销售服务费",
            "answer": "D",
            "explain": "本题考查基金中购赎回的销售服务费。基金管理人可以从开放式基金财产中计提一定比例的销售服务费，用于基金的持续销售和给基金份额持有人提供服务。"
        },
        {
            "title": "关于加强基金管理人的内部控制，以下说法错误的是（　　）。",
            "question": "A. 可以保障基金财产的安全\nB. 可以消除投资者和基金管理人的信息不对称\nC. 可以保障投资者和基金管理人双方的利益\nD. 可以防范基金管理人做出违背投资者利益的行为",
            "answer": "B",
            "explain": "本题考查基金管理人的内部控制。内部控制是指公司为防范和化解风险，在充分考虑内外部环境的基础上，通过建立组织机制，运用管理方法，实施操作程序与控制措施而形成的系统。"
        },
        {
            "title": "以下关于基金公司内部控制机制的定义表述正确的是（　　）。",
            "question": "A. 建立重大决策集体审批制度\nB. 机构为了实现既定目标，防范和减少风险的发生，由全体成员共同参与，对内部业务流程进行全过程的内控，采取权力分配，相互制衡，制定出完备的、制度保证的过程\nC. 强化责任管理、制度管理，规范控制行为\nD. 明确权责体系，规范权力运行，促生内在制约力，形成科学有效的管理机制",
            "answer": "B",
            "explain": "本题考查基金管理人内部控制机制的定义。"
        },
        {
            "title": "公募基金的季报内容可以不包括（　　）。",
            "question": "A. 投资股期货、国债期货的情况\nB. 基金前十名持有人名称\nC. 基金投资的前十名股票明细\nD. 基金概况",
            "answer": "B",
            "explain": "本题考查基金定期公告。基金季度报告主要包括基金概况、主要财务指标和净值表现、管理人报告、投资组合报告、开放式基金份额变动等内容。在季度报告的投资组合报告中，需要披露基金资产组合、按行业分类的股票投资组合、前十名股票明细、按券种分类的债券投资组合、前五名债券明细、投资贵金属、股指期货、国债期货等情况、及投资组合报告附注等内容。"
        },
        {
            "title": "下列属于另类投资基金的是（　　）。",
            "question": "A. 公募指数型证券投资基金\nB. 私募艺术品基金\nC. 货币市场基金\nD. 私募证券投资基金",
            "answer": "B",
            "explain": "本题考查另类投资基金的分类。另类投资基金，是指投资于传统的股票、债券外的金融和实物资产的基金，如房地产、证券化资产、对冲基金、大宗商品、黄金、艺术品等。另类投资基金一般也采用私募方式，种类非常广泛，外延也很不确定，有人将私募股权基金、风险投资基金，对冲基金也列入另类投资基金范围。故本题选B选项。"
        },
        {
            "title": "监事会对基金管理人的业务监督包括（　　）。",
            "questions": "I. 当董事或经理人员开展业务违反法律法规时，通知其停止违法行为<br>II. 随时调查公司的财务状况，审查账册文件，并有权要求董事会向其提供情况<br>III. 审核董事会编制的提供给股东会的各种报表，并把审核意见向股东会报告<br>IV. 当监事会认为有必要时，可以直接召集股东召开股东会",
            "question": "A. I、III、IV\nB. I、II、III\nC. I、II、IV\nD. II、III、IV",
            "answer": "B",
            "explain": "本题考查监事会的合规责任。监事会对经营管理的业务监督包括以下方面："
        },
        {
            "title": "基金管理人应建立电子信息数据的及时保存和备份制度，重要数据应当（　　）。",
            "question": "A. 远程备份并且永久保留\nB. 异地备份并且永久保留\nC. 云端备份并且长期保留\nD. 异地备份并且长期保留",
            "answer": "D",
            "explain": "本题考查基金电子数据的保存及备份。信息技术系统控制的要求基金管理人应建立电子信息数据的即时保存和备份制度，重要数据应当异地备份并长期保存。"
        },
        {
            "title": "根据《证券投资基金法》，基金管理人应当自收到基金产品准予注册文件之日起（　　）个月内进行基金募集。",
            "question": "A. 3\nB. 6\nC. 1\nD. 9",
            "answer": "B",
            "explain": "本题考查基金的募集。募集是指基金管理公司根据有关规定向中国证监会提交募集申请文件、发售基金份额、募集基金的行为。基金管理人应当自收到准予注册文件之日起6个月内(B选项符合题意)进行基金募集。"
        },
        {
            "title": "关于QDII基金信息披露的要求，以下表述错误的是（　　）。",
            "question": "A. 基金管理人在管理QDII基金时，如委托境外托管人，应当在招募说明书中披露境外托管人的有关信息\nB. QDII基金在披露相关信息时可采用中文和英文，并以英文为准\nC. 当涉及币种之间转换的，应披露汇率数据来源，并保持一致性\nD. 基金管理人管理QDII基金时，应当在招募说明书中披露境外市场可能产生的风险信息",
            "answer": "B",
            "explain": "本题考查QDII基金的信息披露。QDII基金是指在一国境内设立，经该国有关部门批准从事境外证券市场的股票、债券等有价证券投资的基金。A选项表述正确，基金管理公司在管理QDII基金时，如委托境外投资顾问、境外托管人，应在招募说明书中披露境外投资顾问和境外托管人的相关信息。"
        },
        {
            "title": "某基金管理公司募集并成立一只QDII房地产基金。根据银行法规，该基金禁止投资于（　　）。",
            "question": "A. 房地产上市公司股票\nB. 住房按揭支持证券\nC. 房地产抵押按揭\nD. 房地产信托凭证",
            "answer": "C",
            "explain": "本题考查QDII基金的投资对象。QDII基金的禁止性行为包括："
        }, {
            "title": "关于基金、股票与债券的特点，以下表述正确的是（　　）。",
            "questions": "I. 基金反映的是一种所有权关系，是一种所有权凭证<br>II. 股票是种直接投资工具，筹集的资金主要投向实业领域<br>III. 债券可以给投资者带来较为确定的利息收入<br>IV. 通常情况下，股票是一种高风险、高收益的投资品种，价格波动性较大",
            "question": "A. II、III、IV\nB. I、II、III、IV\nC. II、IV\nD. I、II、IV",
            "answer": "A",
            "explain": "本题考查基金与股票、债券的差异。"
        },
        {
            "title": "关于QDII基金放开申购赎回后每个开放日的净值披露时限要求是在估值日后（　　）。",
            "question": "A. 2-3个工作日内\nB. 1-2个工作日内\nC. 1-2个自然日内\nD. 2-3个自然日内",
            "answer": "B",
            "explain": "本题考查QDII基金。QDII基金也是开放式基金，在其开放申购、赎回期间，一般至少每周披露一次资产净值和份额净值；开放申购、赎回后，则需要披露每个开放日的份额净值和份额累计净值。QDII基金的净值在估值日后1-2个工作日内披露。"
        },
        {
            "title": "关于基金管理公司董事会风险管理的职责，以下说法错误的是（　　）。",
            "question": "A. 董事会制定公司风险管理战略和风险应对策略\nB. 董事会批准公司基本风险管理制度\nC. 董事会确定公司风险管理总体目标\nD. 董事会对风险管理的有效性承担直接责任",
            "answer": "D",
            "explain": "本题考查董事会风险管理职责。A选项说法正确，制定公司风险管理战略和风险应对策略是董事会的职责。B选项说法正确，董事会负责审批重大风险的解决方案，批准公司基本风险管理制度。C选项说法正确，确定公司风险管理总体目标是董事会的职责。"
        },
        {
            "title": "某基金公司为其新产品举行路演安排，以下不恰当的做法是（　　）。",
            "question": "A. 安排即将参加从业资格考试的实习生接听客服电话\nB. 安排基金经理拜访客户\nC. 安排研究人员回答客户提问\nD. 安排投资总监接受媒体采访，介绍新产品",
            "answer": "A",
            "explain": "本题考查对基金销售人员要求。基金销售机构销售人员应根据有关规定取得中国证券投资基金业协会认可的基金从业人员资格。A选项做法不恰当，实习生尚未取得基金从业资格，因此不能入职工作，因此不能接听客服电话。B、C、D选项做法恰当，基金经理、研究人员、投资总监等，从事本职工作都应具备从业资格，具备从业资格的人员可以拜访客户，回答客户提问，接受媒体采访，介绍新产品。"
        },
        {
            "title": "某投资者赎回开放式基金5万份，对应的顾问费率为0.5%，赎回当日基金份额净值为1.025元，则赎回手续费为（　　）。",
            "question": "A. 256.25元\nB. 252.25元\nC. 250元\nD. 245元",
            "answer": "A",
            "explain": "本题考查基金申购赎回的计算。赎回费用=赎回数量×赎回日基金份额净值×赎回费率由数量可知：赎回数量=5万份，赎回费率=0.5%，赎回当日基金份额净值=1.025元将数值代入公式得，赎回费用=50000×1.025×0.5%=256.25元。"
        },
        {
            "title": "根据《证券投资基金法》的规定，以下各事项中属于公募证券投资基金的招募说明书必备内容的是（　　）。",
            "question": "A. 基金从事证券交易的清算交收安排\nB. 基金管理人和托管人基本情况\nC. 律师事务所为基金募集出具的法律意见书\nD. 基金投资各类证券指令的发送和执行",
            "answer": "B",
            "explain": "本题考查招募说明书的主要披露事项。(1)招募说明书摘要。(2)基金募集申请的核准文件名称和核准日期。(3)基金管理人、基金托管人的基本情况。(B选项正确)(4)基金份额的发售日期、价格、费用和期限。"
        },
        {
            "title": "某证券投资基金合同生效刚满10个月，关于该基金宣传推介材料的业绩登载，下述做法错误的是（　　）。",
            "question": "A. 基金业绩表现数据经过基金托管人复核\nB. 在推介定期定额投资业务时选择了沪深300指数，对其过往足够长时间的实际收益率进行了模拟\nC. 登载了基金管理人管理的其他基金的业绩，同时特别声明其他基金的业绩并不构成对本基金业绩表现的保证\nD. 登载了最近半年的优异业绩表现",
            "answer": "D",
            "explain": "本题考查基金宣传推介材料业绩登载规范。A选项正确，基金业绩表现数据应当经基金托管人复核或者摘取自基金定期报告。B选项正确，对于推介等需要模拟历史业绩的，应当采用我国证券市场或者境外成熟证券市场具有代表性的指数，对其过往足够长时间的实际收益率进行模拟，同时注明相应的复合年平均收益率。C选项正确，基金宣传推介材料登载基金过往业绩的，应当特别声明，基金的过往业绩并不预示其未来表现，基金管理人管理的其他基金的业绩并不构成基金业绩表现的保证。"
        },
        {
            "title": "基金季度报告应该在（　　）编制完成，并进行信息披露。",
            "question": "A. 季度结束之日起30个工作日内\nB. 季度结束之日起20个工作日内\nC. 季度结束之日起15个工作日内\nD. 季度结束之日起15个工作日内",
            "answer": "D",
            "explain": "本题考查基金定期报告。基金季度报告应在每季度结束后15个工作日内(D选项符合题意)，在指定报刊和管理人网站上披露基金季度报告。"
        },
        {
            "title": "以下属于中国证监会，会依法履行的职责是（　　）。",
            "questions": "I. 制定有关证券投资基金活动监管管理的规章、规划<br>II. 对基金当事人之间发生的业务纠纷进行调解<br>III. 对基金管理人、基金托管人以及其他机构从事证券投资基金活动进行监督管理<br>IV. 指导和监督中国证券投资基金业协会的活动",
            "question": "A. I、II、III\nB. I、III、IV\nC. I、II、IV\nD. II、III、IV",
            "answer": "B",
            "explain": "本题考查中国证监会的职责。"
        }, {
            "title": "关于中国证券投资基金业协会理事会，以下表述正确的是（　　）。",
            "question": "A. 理事会成员由会员大会选举产生\nB. 理事会决议须经全体理事三分之二以上表决通过方能生效\nC. 理事会是中国证券投资基金业协会会员大会闭会期间的执行机构\nD. 理事会临时会议须有三分之二以上理事联名方可召开",
            "answer": "C",
            "explain": "本题考查理事会相关内容。A选项表述错误，会员理事由会员大会选举产生，非会员理事由中国证监会委派。"
        },
        {
            "title": "关于QDII基金信息披露的要求，以下表述错误的是（　　）。",
            "question": "A. QDII基金在披露相关信息时，可以采用英文和中文，并以英文为准\nB. 基金管理人在管理QDII基金时，如委托境外托管人，应当在招募说明书中披露境外托管人的有关信息\nC. 基金管理人管理QDII基金时，应当在招募说明书中披露境外市场可能发生的风险信息\nD. 涉及币种之间转换的，应披露汇率数据来源，并保持一致性",
            "answer": "A",
            "explain": "本题考查QDII基金的信息披露。QDII基金是指在一国境内设立，经该国有关部门批准从事境外证券市场的股票、债券等有价证券投资的基金。A选项表述错误，QDII基金在披露相关信息时可采用中文和英文，并以中文为准。"
        },
        {
            "title": "关于公募基金管理公司设立的督察长岗位，以下说法错误的是（　　）。",
            "question": "A. 督察长应经董事会聘任\nB. 督察长可以列席公司相关会议，调阅公司相关档案\nC. 督察长有权就内部控制制度的执行情况独立地履行检查、评价、报告、建议等职能\nD. 督察长对董事会负责",
            "answer": "D",
            "explain": "本题考查基金公司督察长的合规职责。基金管理人应当设立督察长，对董事会负责(D选项表述错误)，经董事会聘任(A选项表述正确)，报中国证监会核准。根据公司监察稽核工作的需要和董事会授权，督察长可以列席公司相关会议，调阅公司相关档案(B选项表述正确)，就内部控制制度的执行情况独立地履行检查、评价、报告、建议职能(C选项表述正确)。"
        },
        {
            "title": "下列关于基金财产的运用，合规的是（　　）。",
            "question": "A. 购买上市公司定向增发的股票\nB. 用于发起设立有限合伙企业\nC. 购买基金托管人的股权\nD. 用于承销公开发行的股票和债券",
            "answer": "A",
            "explain": "本题考查对基金投资与交易行为的限制。根据《证券投资基金法》的规定，基金财产不得用于下列投资或者活动：(1)承销证券(D选项不合规)；(2)违反规定向他人贷款或者提供担保；"
        },
        {
            "title": "基金管理人在进行投资决策业务控制时，为了确保在设立的风险权限额度内进行投资决策，应建立（　　）。",
            "question": "A. 投资风险评估与管理制度\nB. 投资决策授权制度\nC. 实质性审查制度\nD. 业务交流制度",
            "answer": "A",
            "explain": "本题考查投资决策业务控制。基金管理人是基金产品的募集者和管理者，基金管理人在进行投资决策业务控制时应建立投资风险评估与管理制度(A选项符合题意)，在设定的风险权限额度内进行投资决策。"
        },
        {
            "title": "甲资产管理有限公司(以下简称“甲公司”)以非公开方式向投资者募集基金设立某私募基金，该基金组织形式为有限合伙。根据现行自律规则的要求，该基金募集完毕后，甲公司向中国证券投资基金业协会报送的基本信息应当包括（　　）。",
            "questions": "I. 该基金主要投资方向及基金类别<br>II. 合伙协议<br>III. 基金合同<br>IV. 工商登记和营业执照",
            "question": "A. I、II、IV\nB. II、IV\nC. I、II、III、IV\nD. II、III",
            "answer": "A",
            "explain": "本题考查私募基金管理人的登记。"
        },
        {
            "title": "在进行基金产品风险评价时，需要考虑的因素包括（　　）。",
            "questions": "I. 混合型基金投资策略中收益投资和固定收益投资各自的占比<br>II. 基金净值过去三年的回撤率<br>III. 基金托管人的股权结构<br>IV. 基金历史上是否发生过违规信息披露",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、III、IV\nD. I、II、IV",
            "answer": "D",
            "explain": "本题考查风险评价依据。基金产品的风险评价依据包括："
        },
        {
            "title": "根据基金销售适用性的要求，基金销售机构应当建立对基金投资人的调查制度，对基金投资人的（　　）进行调查和评价。",
            "question": "A. 过往投资收益\nB. 资产配置情况\nC. 风险承受能力\nD. 资金来源情况",
            "answer": "C",
            "explain": "本题考查基金销售机构适用性的管理制度。基金销售机构适用性的管理制度包括：(1)对基金管理人进行审慎调查的方式和方法；(2)对基金产品或者服务的风险等级进行设置；(3)对投资者进行分类的方法与程序，投资者转化的方式和程序；"
        },
        {
            "title": "基金管理公司机构设置的原则包括（　　）。",
            "questions": "I. 相互制约原则<br>II. 不相容职责分离原则<br>III. 授权清晰原则<br>IV. 适时性原则",
            "question": "A. I、III、IV\nB. I、II、III\nC. I、II、III、IV\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查机构设置原则。基金管理公司机构设置原则包括：相互制约(I项)和不相容职责分离原则(II项)、授权清晰原则(III项)、适时性原则(IV项)。"
        }, {
            "title": "基金管理人应当自收到投资者的申购(认购)、赎回申请之日起（　　）个工作日内，对该申购(认购)、赎回申请的有效性进行确认。",
            "question": "A. 1\nB. 5\nC. 7\nD. 3",
            "answer": "D",
            "explain": "本题考查资金交收流程。根据规定，基金管理人应当自收到投资者的申购(认购)、赎回申请之日起3个工作日内(D选项符合题意)，对该申购(认购)、赎回申请的有效性进行确认。"
        },
        {
            "title": "关于私募投资基金监督管理，以下说法正确的是（　　）。",
            "question": "A. 建立健全私募基金发行监管制度，注重事前监管\nB. 发行私募基金需经监管机构行政审批\nC. 设立私募基金管理机构需经监管机构行政审批\nD. 允许各类发行主体在依法合规的基础上，向累计不超过法律规定数量的投资者发行私募基金",
            "answer": "D",
            "explain": "本题考查非公开募集基金的基金管理人的登记。B、C选项说法错误，D选项说法正确，根据《证券投资基金法》《私募投资基金监督管理暂行办法》等法律法规规定，私募基金设立私募基金管理机构和发行私募基金不设行政审批(B、C选项，不是需审批)，允许各类发行主体在依法合规的基础上，向累计不超过法律规定数量的投资者发行私募基金。A选项说法错误，建立健全私募基金发行监管制度，切实强化事中事后监管(不包括事前)，依法严厉打击以私募基金为名的各类非法集资活动。"
        },
        {
            "title": "关于证券投资基金的特点，以下表述正确的包括（　　）。",
            "questions": "I. 将资金交给基金管理人管理，使中小投资者能够享受到专业化的投资管理服务<br>II. 证券投资基金实行基金投资人和基金管理人利益共享、风险共担的原则<br>III. 组合投资、分散风险是基金的特色<br>IV. 严格监管与信息透明是公募基金的显著",
            "question": "A. I、III、IV\nB. II、III、IV\nC. I、II、III、IV\nD. I、II、III",
            "answer": "A",
            "explain": "本题考查证券投资基金特点。"
        },
        {
            "title": "基金托管人召集基金份额持有人大会，必须披露的事项不包括（　　）。",
            "question": "A. 召开时间\nB. 份额净值\nC. 会议形式\nD. 审议事项",
            "answer": "B",
            "explain": "本题考查基金托管人的信息披露义务。托管人召集基金份额持有人大会的，应至少提前30日公告大会的召开时间、会议形式、审议事项、议事程序和表决方式等事项。B选项不属于必须披露事项。"
        },
        {
            "title": "基金投资者教育活动的内容不包括（　　）。",
            "question": "A. 风险教育\nB. 投资者维权\nC. 投资咨询\nD. 风险提示",
            "answer": "C",
            "explain": "本题考查由投资者教育的内容。A、D选项符合题意，投资者保护，是指针对个人投资者所进行的有目的、有计划、有组织地传播有关投资知识，传授有关投资经验，培养有关投资技能，倡导理性的投资观念，提示相关的投资风险，告知投资者的权利和保护途径，提高投资者素质的一项系统的社会活动。B选项符合题意，投资者教育的内容包括："
        },
        {
            "title": "关于基金管理人风险管理的内部环境，以下表述错误的是（　　）。",
            "question": "A. 基金管理人内部环境为其它风险管理要素提供规则和结构\nB. 基金管理人内部环境是其它所有风险管理要素的基础\nC. 基金管理人内部环境不包括董事会给予的关注和指导\nD. 基金管理人内部环境特别重要的是经营层的风险偏好",
            "answer": "C",
            "explain": "本题考查企业风险管理基本框架的内容。基金管理人的内部环境是其他所有风险管理要素的基础，为其他要素提供规则和结构，其中特别重要的是经营层的风险偏好(A、B、D选项表述正确)。内部环境的要素包括：全体员工的诚信、道德价值观和胜任能力；管理层的理念和经营风格；管理层分配权力和划分责任，组织和开发其员工的方式，以及董事会给予的关注和指导(C选项表述错误)。"
        },
        {
            "title": "货币市场基金在开放期必须每日披露万份收益和（　　）。",
            "question": "A. 基金累计份额净值\nB. 基金份额净值\nC. 偏离度\nD. 基金7日年化收益率",
            "answer": "D",
            "explain": "本题考查基金净值公告。货币市场基金是货币市场基金，货币市场基金的开放日收益公告主要是指货币市场基金在每个开放日次日披露开放日每万份基金净收益和最近7日年化收益率(D选项符合题意)。"
        },
        {
            "title": "以下从业人员职业道德规范中，属于调节基金从业人员与所在机构关系的是（　　）。",
            "question": "A. 专业审慎\nB. 守法合规\nC. 忠诚尽责\nD. 客户至上",
            "answer": "C",
            "explain": "本题考查忠诚尽责的含义。A选项不符合题意，专业审慎是调整基金从业人员与职业之间关系的道德规范。B选项不符合题意，守法合规是调整基金从业人员与基金行业及基金监管之间的关系。C选项符合题意，忠诚尽责是调整基金从业人员与其所在机构之间关系的职业道德规范。"
        },
        {
            "title": "某公司工商注册地为A省，主要办公地点在B直辖市，该公司计划从事基金销售业务，需要向以下哪个机构注册并取得相应资格（　　）。",
            "question": "A. 在B直辖市的中国证监会派出机构\nB. 在A省或B直辖市的任何一家中国证监会派出机构\nC. 中国证券投资基金业协会\nD. 在A省的中国证监会派出机构",
            "answer": "D",
            "explain": "本题考查基金销售机构的准入条件。商业银行、证券公司、期货公司、保险机构、证券投资咨询机构、独立基金销售机构以及中国证监会认定的其他机构从事基金销售业务的，应当向工商注册登记所在地的中国证监会派出机构进行注册并取得相应资格。上述公司工商注册地为A省，需在A省的中国证监会派出机构注册并取得相应资格。"
        }, {
            "title": "下列表述不属于基金管理人投资合规性风险的是（　　）。",
            "question": "A. 未建立投资对象备选库\nB. 未将基金财产进行合理资产配置\nC. 运用基金财产操纵证券交易价格\nD. 在不同投资组合之间进行利益输送",
            "answer": "B",
            "explain": "本题考查投资合规性风险。投资合规性风险是指基金管理人投资业务人员违反相关法律法规和公司内部规章带来的处罚和损失风险。投资合规性风险的具体情形包括：(1)基金管理人未按法规及基金合同规定建立和管理投资对象备选库(A选项符合题意)；(2)基金管理人利用基金财产为基金份额持有人以外的第三人谋取利益；"
        },
        {
            "title": "关于基金销售机构的义务，以下说法错误的是（　　）。",
            "question": "A. 基金销售机构应开立专门账户收取投资人购买基金份额的款项\nB. 基金销售机构应将基金份额持有人名称、身份信息及份额明细等数据备份至中国证监会认定的机构\nC. 基金销售机构应具有相应的技术设备办理申购业务\nD. 基金销售机构应在销售的与管理人签订销售协议",
            "answer": "B",
            "explain": "本题考查基金销售机构的义务。B项说法错误，基金份额登记机构(并非基金销售机构)应当妥善保存登记数据并将基金份额持有人名称、身份信息及基金份额明细等数据备份至国务院证券监督管理机构认定的机构。"
        },
        {
            "title": "基金从业人员应对自己所在的机构忠诚，以下说法错误的是（　　）。",
            "question": "A. 有义务保护公司财产、信息安全\nB. 严格遵守所在机构的授权制度，在授权范围内履行职责\nC. 提出辞职即可立刻离岗，但需履行保密、竞业禁止等义务\nD. 本人、配偶、利害关系人进行证券投资，应当遵守所在机构有关从业人员的证券投资管理制度办理报备手续",
            "answer": "C",
            "explain": "本题考查忠诚尽责相关内容。忠诚尽责的基本要求包括忠诚和勤勉尽责。A选项说法正确，忠诚廉洁要求应当保护所在机构财产与信息安全，防止所在机构资产损失，丢失。B选项说法正确，勤勉尽责要求应当严格遵守所在机构的授权制度，在授权范围内履行职责。C选项说法错误，基金从业人员提出辞职时，但尚未完成工作移交的，从业人员应认真履行各项义务，不得擅自离岗；已完成工作移交的从业人员应当按照聘用合同的规定，认真履行保密，竞业禁止等义务。"
        },
        {
            "title": "在ETF的招募说明书中，需明确投资者认购、申购、赎回基金份额所涉及的（　　）。",
            "question": "A. 证券价格\nB. 资金金额\nC. 对价种类\nD. 现金替代比例",
            "answer": "C",
            "explain": "本题考查ETF的信息披露。在基金合同和招募说明书中，需明确基金份额的各种认购、申购、赎回方式，以及投资者认购、申购、赎回基金份额涉及的对价种类等。"
        },
        {
            "title": "进行投资者投资决策教育，说法错误的是（　　）。",
            "question": "A. 普及证券市场知识\nB. 指导投资者理性选择\nC. 宣传证券市场法规\nD. 指导投资者紧跟市场热点",
            "answer": "D",
            "explain": "本题考查投资决策教育。A、C选项说法正确，目前，各国投资者教育机构在指定投资者教育策略时，都首先致力于普及证券市场知识和宣传证券市场法规。B选项说法正确，投资决策教育就是要在指导投资者分析投资问题、获得必要信息、进行理性选择的同时，致力于改善投资者决策条件中的某些变量。D选项说法错误，投资决策教育目的是指导投资者分析投资问题，而不是指导投资者紧跟市场热点。"
        },
        {
            "title": "关于货币市场基金的宣传推介，以下做法合规的是（　　）。",
            "question": "A. 销售机构单独摘选基金推介材料中基金管理人过往管理货币市场基金投资收益较高的数据，向投资人宣传\nB. 基金管理人可在基金推介材料中如实列明所管理基金的过往业绩\nC. 可以向投资人承诺本金安全，但是不能承诺最低收益\nD. 在推介材料中如实披露货币市场基金与银行存款及其他产品的投资收益比较",
            "answer": "B",
            "explain": "本题考查货币市场基金的宣传推介。货币市场基金是指仅投资于货币市场工具的基金。A选项做法不合规，陈述所推介基金的过往业绩时，不得夸大或者片面宣传基金的投资收益或过往业绩，着重宣传收益较高的业绩属于片面宣传业绩。B选项做法合规，基金管理人可在基金推介材料中如实列明所管理基金的过往业绩。C选项做法不合规，货币市场基金的宣传推介不得向投资人承诺本金安全，也不能承诺最低收益。D选项做法合规，在推介材料中如实披露货币市场基金与银行存款及其他产品的投资收益比较。"
        },
        {
            "title": "某开放式基金募集期限届满，以下情况满足成功条件的是（　　）。",
            "question": "A. 基金总份额达到5亿份且份额持有人数为100人\nB. 基金份额总额达到1亿份且份额持有人数为100人\nC. 基金份额总额达到2.5亿份且份额持有人数为220人\nD. 基金份额总额达到1.5亿份且份额持有人数为200人",
            "answer": "C",
            "explain": "本题考查基金募集生效的条件。基金募集成功条件之一是：基金募集期限届满，封闭式基金需满足募集的基金份额总额达到核准规模的80%以上，并且基金份额持有人数达到200人以上；开放式基金需满足募集份额总额不少于2亿份，基金募集金额不少于2亿元人民币，基金份额持有人的人数不少于200人。"
        },
        {
            "title": "基金从业人员在执业活动中接触到以下信息中，不属于保密信息的是（　　）。",
            "question": "A. 公司投资标的备选库\nB. 公司产品开发计划\nC. 公司客户申赎记录\nD. 公司已发布的基金年报",
            "answer": "D",
            "explain": "本题考查保守秘密。保守秘密，是指基金从业人员不应泄露客户和所属机构向其传达的信息，除非该信息涉及客户的违法活动，或属于法律要求披露的信息，或客户允许披露此信息。D选项公司已发布的基金年报属于公开信息，不属于保密信息。"
        },
        {
            "title": "以下属于QDII基金临时公告需要披露的事项是（　　）。",
            "questions": "I. 变更境外托管人<br>II. 变更投资顾问<br>III. 投资顾问主要负责人变动<br>IV. 基金资产净值和份额净值",
            "question": "A. I、III、IV\nB. I、II、III\nC. II、III、IV\nD. I、II、IV",
            "answer": "B",
            "explain": "本题考查QDII基金的信息披露。当QDII基金变更境外托管人（I项正确）、变更投资顾问（II项正确）、投资顾问主要负责人变动（III项正确）、涉及境外诉讼等重大事件时，应在事件发生后及时披露临时公告，并在更新的招募说明书中予以说明。"
        }, {
            "title": "下列哪项不属于基金管理人应当采取的会计控制措施（　　）。",
            "question": "A. 建立复核制度\nB. 内外网分离制度\nC. 建立成本控制和业绩考核制度\nD. 建立凭证制度",
            "answer": "B",
            "explain": "本题考查会计系统控制。基金管理人应当采取适当的会计控制措施，以确保会计核算系统的正常运转；(1)应当建立凭证制度(D选项正确)；(2)应当建立账务组织和账务处理体系；(3)应当建立复核制度(A选项正确)；(4)应当采取合理的估值方法和科学的估值程序；"
        },
        {
            "title": "根据《中华人民共和国证券投资基金法》的规定，公开募集证券投资基金的基金管理人和托管人是共同受托人。基金管理人、托管人因共同行为哈基金财产或者基金份额持有人造成损害的，应当如何承担责任（　　）。",
            "question": "A. 基金管理人和托管人按其过错比例各自承担相应的过错责任\nB. 基金管理人和托管人协商承担赔偿责任\nC. 由基金财产承担损失\nD. 基金管理人和托管人承担连带赔偿责任",
            "answer": "D",
            "explain": "本题考查基金管理人，基金托管人的法律责任。"
        },
        {
            "title": "关于中国证券投资基金业协会的组成和性质，以下表述正确的是（　　）。",
            "question": "A. 中国证券投资基金业协会是自律性组织,不具备法人资格\nB. 中国证券投资基金业协会会员包括营造会员、联席会员、观察会员和特别会员\nC. 中国证券投资基金业协会是由基金持有人、基金管理人、基金托管人和基金市场服务机构共同组成的同业协会\nD. 基金托管人可根据自身需要决定是否加入中国证券投资基金业协会",
            "answer": "B",
            "explain": "本题考查中国证券投资基金业协会的组成和性质。基金业协会是证券投资基金行业的自律性组织,是社会团体法人(A选项错误)。基金管理人、基金托管人和基金服务机构，应当依法成立基金业协会(C选项错误)，进行行业自律，协调行业关系，提供行业服务，促进行业发展。基金管理人、基金托管人应当加入基金行业协会(D选项错误);基金服务机构等其他机构可以加入协会成为会员;按照规定在协会登记的基金服务机构应当按照法律法规的规定加入协会成为会员。"
        },
        {
            "title": "下列哪项不属于基金管理人应当采取的会计控制措施（　　）。",
            "question": "A. 建立复核制度\nB. 内外网分离制度\nC. 建立成本控制和业绩考核制度\nD. 建立凭证制度",
            "answer": "B",
            "explain": "本题考查会计系统控制。基金管理人应当采取适当的会计控制措施，以确保会计核算系统的正常运转：(1)应当建立凭证制度(D选项正确)；(2)应当建立账务组织和账务处理体系；(3)应当建立复核制度(A选项正确)；(4)应当采取合理的估值方法和科学的估值程序。"
        },
        {
            "title": "根据《中华人民共和国证券投资基金法》的规定，公开募集证券投资基金的基金管理人和托管人是共同受托人。基金管理人、托管人因共同行为给基金财产或者基金份额持有人造成损害的，应当如何承担责任（　　）。",
            "question": "A. 基金管理人和托管人按其过错比例各自承担相应的过错责任\nB. 基金管理人和托管人协商承担赔偿责任\nC. 由基金财产承担损失\nD. 基金管理人和托管人承担连带赔偿责任",
            "answer": "D",
            "explain": "本题考查基金管理人、基金托管人的法律责任。"
        },
        {
            "title": "关于基金管理人的信息披露，以下表述错误的是（　　）。",
            "question": "A. 基金管理人应当建立完善的信息披露制度，保证公开披露的信息真实、准确、完整、及时\nB. 信息披露是基金管理人必须履行的一项义务\nC. 信息披露不会对证券市场价格和投资者行为产生影响\nD. 基金管理人应当有相应的部门或岗位负责信息披露工作，进行信息的组织、审核和发布",
            "answer": "C",
            "explain": "本题考查基金管理人的信息披露义务。基金信息披露是指基金市场上的有关当事人在基金募集、上市交易、投资运作等环节中，依法向社会公众进行的信息披露。基金管理人主要负责办理与基金财产管理业务活动有关的信息披露事项，具体涉及基金募集、上市交易、投资运作、净值披露等各环节。"
        },
        {
            "title": "甲有1000元闲置资金，希望通过投资实现保值增值，但一千元最多只能购买1、2只股票，因此甲选择购买沪深300指数基金，甲的选择是因为基金具有以下特点（　　）。",
            "question": "A. 严格监控，信息透彻\nB. 利益共享，风险共担\nC. 组合投资，分散风险",
            "answer": "C",
            "explain": "本题考查证券投资基金的基本特点。甲因资金有限，只能购买1、2只股票，故甲选择购买沪深300指数基金。沪深300指数基金以沪深300指数为标的指数，并以该指数的成份股为投资对象，通过购买该指数的全部或部分成份股构建投资组合。这体现了证券投资基金组合投资、分散风险的特点(D选项符合题意)。"
        },
        {
            "title": "关于私募基金的风险揭示书，以下说法正确的是（　　）。",
            "question": "A. 如果有私募基金管理人自行销售的，应当由私募基金管理人签字确认，如果委托销售机构销售的应当由销售机构签字确认\nB. 应当由私募基金管理人签字确认\nC. 应由委托销售机构签字确认\nD. 当由投资者签字确认",
            "answer": "D",
            "explain": "本题考查私募基金的风险揭示书。私募基金管理人自行销售私募基金的，应当采取问卷调查等形式，对投资者的风险识别能力和风险承担能力进行评估，由投资者书面承诺符合合格投资者条件，应当制作风险揭示书，由投资者签字确认(A、B、C选项说法错误，而不是其他人签字)。"
        },
        {
            "title": "关于资产管理的特征，以下表述正确的是（　　）。",
            "question": "A. 资产管理的受托人主要通过投资于实物资产实现管理资产的增值\nB. 资产管理的委托方为投资人受托方为资产管理人\nC. 受托管理的资产主要是能产生现金流入的固定资产\nD. 资产管理的委托人委托受托人管理资产往往是以非盈利为目的",
            "answer": "B",
            "explain": "本题考查资产管理的特征。资产管理一般是指金融机构受投资者委托，为实现投资者的特定目标和利益，进行证券和其他金融产品的投资并提供金融资产管理服务，收取费用的行为。(D选项错误)资产管理具有以下特征："
        },
        {
            "title": "基金销售人员的以下行为中，不合规的是（　　）。",
            "question": "A. 向不同风险承受能力的投资者推介不同的基金\nB. 向投资者进行基金宣传推介和销售服务时，公平对待投资者\nC. 向投资者重点揭示基金投资风险\nD. 向个别认购金额较大的投资者收取费用低于招募说明书中所列费率",
            "answer": "D",
            "explain": "本题考查基金销售人员基本行为规范。D项错误,不可以向个别认购金额较大的投资者收取费用低于招募说明书中所列费率。基金销售人员在向投资者办理基金销售业务时,应当按照基金合同、招募说明书和发行公告等销售法律文件的规定代扣或收取相关费用，不得收取其他额外费用，也不得对不同投资者违规收取不同费率的费用。"
        },
        {
            "title": "基金份额登记机构应妥善保存登记数据，保存期限为（　　）。",
            "question": "A. 自基金账户销户之日起不得少于20年\nB. 自基金账户开户之日起不得少于20年\nC. 自基金账户开户之日起不得少于15年\nD. 自基金账户销户之日起不得少于15年",
            "answer": "A",
            "explain": "本题考查基金经营机构客户信息保存期限有关规定。《证券投资基金法》规定，基金份额登记机构应当妥善保存登记数据，并将基金份额持有人名称、身份信息及基金份额明细等数据备份至中国证监会认定的机构，其保存期限自基金账户销户之日起不得少于20年。"
        },
        {
            "title": "基金合同生效六个月以上不满一年的，以下说法正确的是（　　）。",
            "question": "A. 宣传材料可以登载基金历史业绩，业绩自基金合同生效六个月起算\nB. 宣传材料可以登载基金历史业绩，业绩自基金合同生效之日起算\nC. 宣传材料可以登载基金历史业绩，业绩自基金合同生效满90天起算\nD. 宣传材料不可以登载基金历史业绩",
            "answer": "B",
            "explain": "本题考查基金宣传推介材料业绩登载规范。基金合同生效6个月以上但不满1年的，应当登载从合同生效之日起计算的业绩(B选项符合题意)。"
        }, {
            "title": "关于基金销售适用性的全面性原则，以下表述错误的是（　　）。",
            "question": "A. 基金销售机构应当将基金销售适用性作为内部控制的组成部分\nB. 基金销售机构应当将基金销售适用性贯穿基金销售的各个业务环节\nC. 基金销售机构应当向基金投资者提供全面丰富的产品和服务\nD. 基金销售机构应当对基金管理人、基金产品和基金投资人进行了解并做出评价",
            "answer": "C",
            "explain": "本题考查基金销售适用性的全面性原则。全面性原则是指销售机构应当将基金销售适用性作为内部控制的组成部分，将基金销售适用性贯穿于基金销售的各个业务环节，对基金管理人品发起，基金产品和基金投资人都要了解并做出评价。"
        },
        {
            "title": "某股份制商业银行，在一个小县城新开设了营业网点，为了吸引更多客户前来选购基金产品，开展了以下宣传活动，其中符合基金销售费用规范的是（　　）。",
            "question": "A. 网银申购基金，手续费8折优惠\nB. 当日购买基金，手续费先收后返\nC. 买基金，送保险\nD. 客户预约购买，发放现金红包",
            "answer": "A",
            "explain": "本题考查基金销售费用的具体规范。基金销售机构在基金销售活动中，不得有下列行为：(1)在签订销售协议或销售基金的活动中进行商业贿赂；"
        },
        {
            "title": "要求基金公司合规人员应当了解公司各种业务的运作流程和法律法规，依据的是合规管理中的（　　）。",
            "question": "A. 专业性原则\nB. 客观性原则\nC. 公正性原则\nD. 独立性原则",
            "answer": "A",
            "explain": "本题考查合规管理的基本原则。A选项符合题意，专业性原则是指合规人员应当熟悉业务制度，了解基金管理人各种业务的运作流程，并准确理解和把握法律法规的规定和变动趋势。"
        },
        {
            "title": "关于公募基金的临时信息披露，下列错误的是（　　）。",
            "question": "A. 基金的重大事件可包括基金经理变更，基金持仓股票出现连续2个以上跌停，开放式基金发生巨额赎回\nB. 如果预期某种信息可能对基金份额持有人权益或基金份额的价格产生重大影响，则应临时披露报告\nC. 对于任何公共媒体出现的，可能损害基金份额持有人权益的信息均应立即公开澄清\nD. 信息披露义务人应在重大事件发生之日起2日内编制并披露临时报告书",
            "answer": "A",
            "explain": "本题考查基金临时信息披露的内容。当发生重大事件时，信息披露义务人应当在重大事件发生之日起2日内编制并披露临时报告书。基金重大事件包括："
        },
        {
            "title": "关于私募机构资产管理业务，以下表述错误的是（　　）。",
            "question": "A. 私募基金需要面向合格投资者募集，人数累计不超200人\nB. 社会保障基金、企业年金可以视为私募基金的合格投资者\nC. 私募基金需要行政审批\nD. 合格投资者于单只私募基金的金额不低于100万元",
            "answer": "C",
            "explain": "本题考查私募机构资产管理业务。C项说法错误，根据《证券投资基金法》《私募投资基金监督管理暂行办法》等法律法规规定，私募基金设立私募基金管理机构和发行私募基金不设行政审批，允许各类发行主体在依法合规的基础上，向累计不超过法律规定数量的合格投资者发行私募基金。"
        },
        {
            "title": "关于基金销售费用结构的内容，以下表述错误的是（　　）。",
            "question": "A. 认购费和申购费可以采用前端收费方式，也可以采用后端收费方式\nB. 为鼓励长期持有，基金管理人对选择后端收费方式的投资人可以根据持有时间长短适当优惠\nC. 基金管理人办理开放式基金份额的赎回，应当收取相应的赎回费\nD. 为保证公平，基金管理人对选择前端收费方式的投资人要设置同一费率标准",
            "answer": "D",
            "explain": "本题考查基金销售费用的内容。基金管理人可以从开放式基金财产中计提一定比例的销售服务费，用于基金的持续销售和给基金份额持有人提供服务。"
        },
        {
            "title": "基金管理人服务于基金持有人的价值主要体现在（　　）。",
            "question": "A. 建立健全管理制度，满足监管要求\nB. 不断增加管理规模，为基金公司股东追求最大回报\nC. 不断提升品牌知名度，为基金公司员工提供优质平台\nD. 基金的投资管理",
            "answer": "D",
            "explain": "本题考查基金服务的价值。证券投资基金是指通过发售基金份额，将众多不特定投资者的资金汇集起来，形成独立财产，委托基金管理人进行投资管理，托管人进行财产托管，由基金投资人共享投资收益，共担投资风险的集合投资方式。"
        },
        {
            "title": "关于中国证券投资基金业协会的性质和组成，以下表述错误的是（　　）。",
            "question": "A. 《证券投资基金法》关于“基金行业协会”的章节详细规定了中国证券投资基金业协会的性质\nB. 基金管理人、基金托管人应当加入中国证券投资基金业协会，基金服务机构等其他机构可以加入协会成为会员\nC. 中国证券投资基金业协会是证券投资基金行业的自律性组织，也是基金市场的政府监管机构\nD. 中国证券投资基金业协会会员依据《中国证券投资基金业协会章程》和《中国证券投资基金业协会会员管理办法》的规定参与协会治理",
            "answer": "C",
            "explain": "本题考查中国证券投资基金业协会的性质和组成。A选项表述正确，《证券投资基金法》关于“基金行业协会”的章节详细规定了中国证券投资基金业协会的性质，组成以及主要职责。基金业协会是证券投资基金行业的自律性组织，是社会团体法人。基金行业协会会员包括普通会员，联席会员，观察会员和特别会员。"
        },
        {
            "title": "商业银行从事基金销售业务，应向（　　）进行注册并取得相应资格。",
            "question": "A. 中国人民银行\nB. 中国证券投资基金业协会\nC. 中国银保监会\nD. 工商注册登记所在地的中国证监会派出机构",
            "answer": "D",
            "explain": "本题考查基金销售机构的准入条件。商业银行、证券公司、期货公司、保险机构、证券投资咨询机构、独立基金销售机构以及中国证监会认定的其他机构申请注册基金销售业务资格，应满足相应要求，从事基金销售业务的，应向工商注册登记所在地的中国证监会派出机构进行注册并取得相应资格。"
        },
        {
            "title": "关于基金管理公司的风险管理，以下表述错误的是（　　）。",
            "question": "A. 基金管理公司应树立内控优先和全员风险管理理念\nB. 风险管理是公司风险管理部门的责任，其它业务部门只需提供配合\nC. 基金管理公司应将风险管理纳入各部门和所有员工年度绩效考核范围\nD. 公司所有员工是本岗位风险管理的直接责任人",
            "answer": "B",
            "explain": "本题考查风险管理。A、C项正确，在风险管理中，基金公司最重要的是要在全公司坚持不懈推动风险管理的理念和文化，推动风险管理意识渗入到公司的每一项业务和企业文化中，要求全体员工牢固树立内控优先和全员风险管理理念。"
        }, {
            "title": "封闭式基金的折价率是指（　　）。",
            "question": "A. 基金份额净值/单位市价\nB. （基金份额净值-单位市价）/单位市价\nC. （基金份额净值-单位市价）/基金份额净值\nD. 单位市价/基金份额净值",
            "answer": "C",
            "explain": "本题考查封闭式基金的折(溢)价率计算公式。投资者常常使用折（溢）价率反映封闭式基金份额净值与其二级市场价格之间的关系，其计算公式为：折价率=（基金份额净值-二级市场价格）／（基金份额净值）。"
        },
        {
            "title": "下列不属于财产分离内控要求的选项是（　　）。",
            "question": "A. 确保不同基金财产之间的分离\nB. 确保同一基金内不同投资项目的分离\nC. 确保基金财产与管理人自有财产之间的分离\nD. 确保基金财产与基金份额持有人自有财产之间的分离",
            "answer": "B",
            "explain": "本题考查基金财产的独立性。A项属于财产分离内控要求，基金管理人不能在同一证券账户内同时管理固有资金和受托资金，必须将信托财产与其固有财产分别管理、分别记账，并将不同委托人的信托财产分别管理、分别记账。C、D项属于财产分离内控要求，基金财产是独立于基金管理人、基金托管人的固有财产。基金管理人、基金托管人不得将基金财产归入其固有财产。"
        },
        {
            "title": "QDII基金投资境外基金的，招募说明书中不需披露的信息是（　　）。",
            "question": "A. 境外基金的收益排名\nB. 境外基金的托管人信息\nC. 基金与境外基金之间的费率安排\nD. 境外基金的投资标的",
            "answer": "A",
            "explain": "本题考查QDII基金的信息披露。QDII基金投资境外基金，基金合同、基金招募说明书中要求披露：(1)境外投资顾问和境外托管人信息。(2)投资交易信息。如QDII基金投资金融衍生品，应在基金合同、招募说明书中详细说明拟投资的衍生品种及其基本特性，拟采取的组合避险、有效管理策略及采取的方式、频率。如QDII基金投资境外基金，应披露基金与境外基金之间的费率安排。(3)投资境外市场可能产生的风险信息，包括境外市场风险、政府管制风险、政治风险、流动性风险、信用风险等的定义、特征及可能发生的后果。"
        },
        {
            "title": "关于中国证券投资基金业协会的会员类别，以下说法正确的是（　　）。",
            "question": "A. 分为境外会员和境内会员\nB. 公募基金管理人应当成为普通会员\nC. 基金托管人可以选择是否入会\nD. 分为特殊会员和普通会员",
            "answer": "B",
            "explain": "本题考查基金业协会会员。A、D选项说法错误，基金业协会的会员包括：普通会员，观察会员、联席会员，特别会员。B选项说法正确，公募基金的基金管理人，基金托管人加入基金业协会的，为普通会员。C选项说法错误，管理人、托管人应该加入基金业协会，而非可以选择入会。"
        },
        {
            "title": "以下属于证券投资基金所有者的是（　　）。",
            "question": "A. 基金评级机构\nB. 基金托管人\nC. 基金投资人\nD. 基金管理人",
            "answer": "C",
            "explain": "本题考查证券投资基金的参与主体。基金份额持有人即基金投资者，是基金的出资人、基金资产的所有者和基金投资回报的受益人。"
        },
        {
            "title": "按照运作方式，可将证券投资基金分为（　　）。",
            "question": "A. 封闭式基金与开放式基金\nB. 在岸基金与离岸基金\nC. 主动型基金与指数型基金\nD. 契约型基金与公司型基金",
            "answer": "A",
            "explain": "本题考查基金的不同分类方式。A选项符合题意，投资基金按照运作方式的不同，分为开放式基金、封闭式基金。B选项不符合题意，投资基金按照来源的不同，分为在岸基金与离岸基金。"
        },
        {
            "title": "守法合规是基金从业人员职业道德的基础要求，基金从业人员守法合规的目的包括（　　）。",
            "questions": "I. 避免实施违法违规行为<br>II. 与监管机构共同制定监管政策<br>III. 避免参与他人实施的违法违规行为<br>IV. 参与监管机构的执法活动",
            "question": "A. I、II、III、IV\nB. I、III、IV\nC. I、II、III\nD. I、III",
            "answer": "D",
            "explain": "本题考查守法合规的目的。I、III项属于守法合规的目的，守法合规的目的是避免基金从业人员自己实施或者参与违法违规的行为，或者为他人违法违规的行为提供帮助。"
        },
        {
            "title": "某基金公司准备对其旗下A、B、C和D基金的业绩进行宣传，关于各只基金的过往业绩宣传推介，以下表述不正确的是（　　）。",
            "question": "A. B基金合同生效10个月，需要登载从B基金合同生效之日起的业绩表现\nB. D基金合同生效12年，需要登载最近10个完整会计年度的业绩表现\nC. A基金合同生效3个月，需要登载近3个月业绩表现\nD. C基金合同生效5年，需要登载自合同生效当年至今所有完整会计年度的业绩情况",
            "answer": "C",
            "explain": "本题考查宣传推介材料业绩登载规范。A选项说法正确基金合同生效6个月以上但不满1年的，应当登载从合同生效之日起计算的业绩。B选项说法正确，基金合同生效10年以上的，应当登载最近10个完整会计年度的业绩。C选项说法错误，基金合同生效不足6个月，不需要登载业绩表现。"
        },
        {
            "title": "下列做法中符合基金客户利益至上的是（　　）。",
            "question": "A. 基金经理根据公司投决会决议，操作自己管理的基金购买朋友公司发行的优质公司债\nB. 基金经理操作其亲属证券账户，先于自己管理的基金买卖相同个股\nC. 银行理财经理向某客户销售500万元某基金产品，安排客户分10笔各50万元申购，以提升其销售业绩\nD. 基金托管人将某基金的托管资金放贷给其优质客户，用于提升收益，支持实体经济",
            "answer": "A",
            "explain": "本题考查客户至上的基本要求。"
        }, {
            "title": "以下属于基金专业投资者的是（　　）。",
            "questions": "I. 商业银行理财产品<br>II. 证券公司资管计划<br>III. 信托公司信托计划<br>IV. 保险公司保险产品",
            "question": "A. II、III、IV\nB. I、III、IV\nC. I、II、III、IV\nD. I、II",
            "answer": "C",
            "explain": "本题考点为专业投资者。符合以下条件之一的为专业投资者：商业银行理财产品、证券公司资产管理计划、信托公司信托计划、保险公司保险产品。"
        },
        {
            "title": "关于设立公募基金管理公司，以下符合设立要求的是（　　）。",
            "questions": "I. 公司实缴注朋资本为2亿元<br>II. 公司主要股东最近2年没有违法记录<br>III. 公司拟设独立董事3人，占童事会成员人数的1/3<br>IV. 公司有正式员工20人，除拟任总经理之外，均取得基金从业资格",
            "question": "A. II、III\nB. I、III\nC. I、IV\nD. II、IV",
            "answer": "B",
            "explain": "本题考查基金管理公司的设立条件。设立管理公开募集基金的基金管理公司，应具备下列条件：（1）有符合《证券投资基金法》和《中华人民共和国公司法》（简称《公司法》）规定的章程；（2）注册资本不低于1亿元人民币，且必须为实缴货币资本；（3）主要股东应当具有经营金融业务或者管理金融机构的良好业绩、良好的财务状况和社会信誉，资产规模达到国务院规定的标准，最近3年没有违法记录；（4）取得基金从业资格的人员达到法定人数；（5）董事、监事、高级管理人员具备相应的任职条件；（6）有符合要求的营业场所、安全防范设施和与基金管理业务有关的其他设施；（7）有良好的内部治理结构、完善的内部稽核监控制度和风险控制制度；（8）法律、行政法规规定的和经国务院批准的国务院证券监督管理机构规定的其他条件。公司主要股东为法人或者其他组织的，净资产不低于2亿元人民币；设立基金管理公司，应当有符合法律、行政法规和中国证监会规定的拟任高级管理人员以及从事研究、投资、估值、营销等业务的人员，拟任高级管理人员、业务人员不少于15人，并应当取得基金从业资格。本题中I项，公司实缴注册资本为2亿元，符合要求；II项，主要股东要求净资产不低于2亿元，不是实缴资本，不符合；III项，公司拟设立独立董事3人，占董事会成员人数的1/3，符合要求；IV项，公司正式员工人数不符合相关规定人数要求，不符合。"
        },
        {
            "title": "下列不属于基金合同当事人的是（　　）。",
            "question": "A. 基金托管人\nB. 基金销售机构\nC. 基金的持有人\nD. 基金管理人",
            "answer": "B",
            "explain": "本题考查基金当事人。证券投资基金合同的当事人包括基金管理人、基金托管人和基金的持有人。B选项符合题意，基金销售机构是基金市场服务机构。"
        },
        {
            "title": "A基金管理公司旗下公募基金野樱莓基金持有的债券出现估值日当日不具备活跃市场，第三方估值机构和当日没有提供估值价格为20元。A基金管理公司当日用估值技术确定的该估值价格为21元，第三方估值机构和次日提供的估值价格为19元。A基金管理公司遂对该估值调整并公告。该机构若投资人在A基金管理公司购买野樱莓基金份额，关于此案例，以下描述错误的是（　　）。",
            "question": "A. A基金管理公司向估值专家委员会申请复核，属于违规行为\nB. A基金管理公司有信息披露的及时性原则\nC. A基金管理公司对于债券被露的时间和发布环节存在内控失误，应追究相关人员的责任\nD. A基金管理公司有信息披露的准确性法规职责",
            "answer": "D",
            "explain": "本题考查基金信息披露的禁止行为。A选项说法正确，D选项说法错误，基金管理人不能泄露未公开信息，A基金管理公司制定资产估值并公开信息，属于违规行为；B选项说法正确，及时性原则要求以最快的速度公开信息，使信息处于最新状态，体现在基金管理人应在法定期限内披露基金招募说明书、定期报告等文件，在重大事件发生之日起2日内披露临时报告；C选项说法正确，A基金管理公司在信息披露的时间和发布环节存在内控失误，应追究相关人员的责任。"
        },
        {
            "title": "甲基金管理公司的某特定客户资产管理计划持有较高比例的某信用债券A和部分非公开开发行股票及货币市场基金，其中A债券的持仓占该组合的50%，该资产管理计划的开放期前，A债券的发行人的上市母公司财务报表出现造假，导致A债券出现连续多日的大幅度的市值下跌和成交萎缩，在开放期已无法卖出成交。该基金管理公司的风险管理部在开放期前未检测到债券发行人母公司的该负面信息，也未将单一债券品种波动纳入监控指标。该产品的投资经理虽已在开放期知晓该信息且预感债券A收益率将大幅度变化，但其他类似债券发行人现金流充裕，偿债能力较强。另外，根据公司制度，投资经理本应就超过组合资产净值10%债券的风险事件及时向公司信用风险管理委员会报告，最终由于该债劵开放后投资人退出比例高达50%以上，导致管理人未能按资产管理合同支付退出资金。(1) 本案例包含了多种风险情形，以下选项中，与本案例所涉及的风险类别无关的是（　　）。",
            "question": "A. 操作风险\nB. 流动性风险\nC. 估值风险\nD. 信用风险",
            "answer": "C",
            "explain": "本题考查风险分类。"
        },
        {
            "title": "甲基金管理公司的某特定客户资产管理计划持有较高比例的某信用债券A和部分非公开开发行股票及货币市场基金，其中A债券的持仓占该组合的50%，该资产管理计划的开放期前，A债券的发行人的上市母公司财务报表出现造假，导致A债券出现连续多日的大幅度的市值下跌和成交萎缩，在开放期已无法卖出成交。该基金管理公司的风险管理部在开放期前未检测到债券发行人母公司的该负面信息，也未将单一债券品种波动纳入监控指标。该产品的投资经理虽已在开放期知晓该信息且预感债券A收益率将大幅度变化，但其他类似债券发行人现金流充裕，偿债能力较强。另外，根据公司制度，投资经理本应就超过组合资产净值10%债券的风险事件及时向公司信用风险管理委员会报告，最终由于该债劵开放后投资人退出比例高达50%以上，导致管理人未能按资产管理合同支付退出资金。(2) 关于该基金公司在本案例中暴露出的风险管理缺陷，以下表述错误的是（　　）。",
            "question": "A. 风险管理部未及时监测到债券风险，体现了负面舆情信息收集环节存在缺陷\nB. 该投资经理未及时向信用风险管理委员会汇报风险情况，体现了信用风险信息的汇报机制设计存在缺陷\nC. 风险管理部未监控组合债券的收益率大幅度波动情况，体现了债券的风险监控指标体系存在缺陷\nD. 因资产管理计划开放期单一债券持仓比例较高并无法变现，体现了投资组合的投资集中度和流动性管理策略尚不够完善",
            "answer": "B",
            "explain": "本题考查风险分类。"
        },
        {
            "title": "甲基金管理公司的某特定客户资产管理计划持有较高比例的某信用债券A和部分非公开开发行股票及货币市场基金，其中A债券的持仓占该组合的50%，该资产管理计划的开放期前，A债券的发行人的上市母公司财务报表出现造假，导致A债券出现连续多日的大幅度的市值下跌和成交萎缩，在开放期已无法卖出成交。该基金管理公司的风险管理部在开放期前未检测到债券发行人母公司的该负面信息，也未将单一债券品种波动纳入监控指标。该产品的投资经理虽已在开放期知晓该信息且预感债券A收益率将大幅度变化，但其他类似债券发行人现金流充裕，偿债能力较强。另外，根据公司制度，投资经理本应就超过组合资产净值10%债券的风险事件及时向公司信用风险管理委员会报告，最终由于该债劵开放后投资人退出比例高达50%以上，导致管理人未能按资产管理合同支付退出资金。(3) 针对本案例，该基金管理公司可从以下多项改进措施，其中与防范本案例所暴露的风险不直接相关的是（　　）。",
            "question": "A. 通过制度和系统建设实现人工和系统的双重风险识别机制\nB. 要求风险管理部每日对重点债券的收益率波动进行跟踪监测和风险预警\nC. 改为10%为5%，即计划持仓5%的债券发生风险时，投资经理即应向公司信用风险管理委员会报告\nD. 对所有开放期安排的资产管理计划要求更为分散的投资管理策略，并在开放期前对资产的流动性进行检查。",
            "answer": "C",
            "explain": "本题考查风险分类。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/flfg-3.js